import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import { MoneyflowPageDispatchProps, MoneyflowPageStateProps } from 'interfaces/moneyflow'
import IncomePage from 'components/features/pfm/IncomePage/IncomePage'
import internal from 'components/utils/Internal'

const mapStateToProps = (state: State): MoneyflowPageStateProps => ({
  categoryId: state.app.income.categories.selectedId,
  timeframe: state.app.income.timeframe,
})

const IncomeContainer = internal(connect<
  MoneyflowPageStateProps, MoneyflowPageDispatchProps
>(mapStateToProps)(IncomePage))
export default IncomeContainer
